import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const TermosPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F5D79C]">
      {/* Header */}
      <div className="bg-transparent py-4 px-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <button 
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[#7A5948] hover:text-[#5D4A3A] transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Voltar
          </button>
          <h1 className="text-xl font-bold text-[#7A5948]">Termos e Privacidade</h1>
          <div className="w-16"></div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 pb-8">
        <div className="bg-[#FBE4AD] rounded-[20px] p-6 md:p-8">
          <div className="prose prose-sm max-w-none text-[#7A5948]" style={{ lineHeight: '1.6' }}>
            <p className="text-sm text-[#7A5948] mb-6">
              <strong>Última atualização:</strong> 16 de janeiro de 2026.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">1. ACEITAÇÃO DOS TERMOS</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              Ao criar uma conta ou utilizar o aplicativo Miaucaomigo, você declara que leu, compreendeu e concorda integralmente com estes Termos de Uso e com a nossa Política de Privacidade.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">2. OBJETIVO DO APLICATIVO</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              O Miaucaomigo é uma plataforma de apoio à adoção responsável de animais, permitindo o cadastro e a visualização de animais, bem como o compartilhamento de informações sobre localização e cuidados, sempre priorizando o bem-estar animal.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">3. CADASTRO E RESPONSABILIDADE DO USUÁRIO</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              O usuário compromete-se a fornecer informações verdadeiras, completas e atualizadas, utilizar apenas imagens e conteúdos de sua autoria ou devidamente autorizados, e manter a confidencialidade de seus dados de acesso. O uso indevido da plataforma poderá resultar na suspensão ou exclusão da conta.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">4. CONTEÚDO INSERIDO PELO USUÁRIO</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              Todo conteúdo publicado no aplicativo é de inteira responsabilidade do usuário. O Miaucaomigo não se responsabiliza por informações incorretas, imagens inadequadas ou ações tomadas por terceiros com base nesses dados.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">5. LOCALIZAÇÃO E REGISTROS</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              O aplicativo pode utilizar dados de localização para indicar onde um animal foi avistado. Os registros possuem caráter temporário e podem expirar após determinado período, com o objetivo de manter as informações atualizadas.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">6. BEM-ESTAR ANIMAL E CONDUTAS PROIBIDAS</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              O Miaucaomigo não tolera qualquer forma de maus-tratos a animais. Denúncias ou indícios de abuso, negligência ou uso indevido da plataforma poderão resultar no banimento imediato da conta.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">7. PRIVACIDADE E PROTEÇÃO DE DADOS</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              Os dados pessoais coletados são tratados conforme a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD) e de acordo com a nossa Política de Privacidade.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">8. LIMITAÇÃO DE RESPONSABILIDADE</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              O Miaucaomigo atua como uma plataforma intermediária e não garante a adoção efetiva dos animais, a veracidade absoluta das informações fornecidas por usuários ou a conduta de terceiros, ONGs ou adotantes.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">9. ALTERAÇÕES DOS TERMOS</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              Estes Termos de Uso podem ser atualizados a qualquer momento. O uso contínuo do aplicativo após alterações implica na aceitação automática da versão atualizada.
            </p>

            <h2 className="text-lg font-bold text-[#7A5948] mt-6 mb-3">10. CONTATO</h2>
            <p className="text-[15px] text-[#7A5948] mb-4">
              Em caso de dúvidas ou solicitações, entre em contato pelo e-mail: <a href="mailto:miaucaomigo@gmail.com" className="text-[#6B5344] hover:underline font-semibold">miaucaomigo@gmail.com</a>
            </p>
          </div>
        </div>

        {/* Button */}
        <div className="mt-6 px-4">
          <Button
            onClick={() => navigate(-1)}
            className="w-full btn-primary h-14 text-lg font-bold uppercase"
          >
            ENTENDI
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TermosPage;
